import { render, staticRenderFns } from "./pnrbul.vue?vue&type=template&id=1c60eb3c&"
import script from "./pnrbul.vue?vue&type=script&lang=js&"
export * from "./pnrbul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports